import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAuthUser from "../../../hooks/useAuthUser.js";

const TabNavigation = () => {
  const { loggedInUser } = useAuthUser();
  const userRole = Number(loggedInUser?.role);

  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [];

  if ([1, 2].includes(userRole)) {
        tabs.push({ name: "Dashboard", path: "/learning-and-development/dashboard" });
        tabs.push({ name: "Internal Program Categories", path: "/learning-and-development/program-categories" });
        tabs.push({ name: "Internal Learning Program", path: "/learning-and-development/learning-program" });
        tabs.push({ name: "Assign Internal Program", path: "/learning-and-development/assign-program" });
  }

  // 1 - admin, 5 - manager, 2- hr-manager
  if ([1, 5, 2].includes(userRole)) {
        tabs.push({ name: "External User Program Request", path: "/learning-and-development/user-program-request" });
  }

  if ([7].includes(userRole)) {
        tabs.push({ name: "Dashboard", path: "/learning-and-development/dashboard" });
        tabs.push({ name: "My Internal Program", path: "/learning-and-development/user-learning-program" });
  }
  
  if ([7].includes(userRole)) {
        tabs.push({ name: "External Program Request", path: "/learning-and-development/program-request" });
  }

  useEffect(() => {
    const isValidPath = tabs.some(tab =>
      location.pathname === tab.path ||
      location.pathname.startsWith(`${tab.path}/`)
    );

    if (!isValidPath) {
      navigate(tabs[0].path, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <ul className="nav nav-tabs" role="tablist">
      {tabs.map(tab => {
        const isActive =
          location.pathname === tab.path ||
          location.pathname.startsWith(`${tab.path}/`);

        return (
          <li className="nav-item" key={tab.path}>
            <button
              className={`nav-link ${isActive ? "active" : ""}`}
              onClick={() => navigate(tab.path)}
              type="button"
            >
              {tab.name}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default TabNavigation;
